import { Flex, Text } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"
import { ApplicationTag } from "@/molecules/ApplicationTag"

import styles from "./ImpactCell.module.scss"

export const TitleImpactPopover = (props: {
  total: number
  active: number
  inactive: number
}) => {
  const { t } = useTranslation("translation", {
    keyPrefix: "triage.drawer.impact"
  })
  const { active, inactive } = props
  const live = active + inactive

  return (
    <Flex vertical className={styles.popoverTitle} gap={8}>
      <Text strong>{t("live", { count: live })}</Text>
      <Flex align="center" gap={16} className={styles.popoverTitleWrapper}>
        <ApplicationTag count={active} type="active" />
        <ApplicationTag count={inactive} type="inactive" />
      </Flex>
    </Flex>
  )
}
